import moment from "moment-timezone";
import logger from "../lib/logger";

export const formatDate = (unixTimestamp: string | number): string | null => {
  try {
    const date = parseInt(unixTimestamp as string) / 10000;
    const userTimezone = moment.tz.guess();

    if (moment(date).isValid()) {
      return moment(date)
        .tz(userTimezone)
        .format("MMM DD, YYYY hh:mm A [" + moment.tz(userTimezone).zoneAbbr() + "]");
    } else {
      logger.warn("Invalid date format");
      return null;
    }
  } catch (error: any) {
    logger.error("Error formatting date:", error);
    return null;
  }
};

export const formatRelativeTime = (unixTimestamp: string | number): string | null => {
  try {
    const date = parseInt(unixTimestamp as string) / 10000;
    const userTimezone = moment.tz.guess();

    if (moment(date).isValid()) {
      return moment(date).tz(userTimezone).fromNow();
    } else {
      logger.warn("Invalid date format");
      return null;
    }
  } catch (error: any) {
    logger.error("Error formatting relative time:", error);
    return null;
  }
};
